import type { NavigationGuardWithThis } from 'vue-router';
import { resolveRandomisedProductHandle } from '@/features/Product/composables/productRandomisation';

type ProductRandomisationHistoryState = {
  resolvedProductHandle?: string;
};

let pendingRandomisedHandle: string | null = null;

export const productRandomisationGuard: NavigationGuardWithThis<undefined> = (to, _from, next) => {
  if (to.name !== 'product' || typeof to.params.handle !== 'string') {
    pendingRandomisedHandle = null;
    return next();
  }

  const handle = to.params.handle;
  const restoredHandle = (window.history.state as ProductRandomisationHistoryState | null)
    ?.resolvedProductHandle;
  if (handle === pendingRandomisedHandle || handle === restoredHandle) {
    pendingRandomisedHandle = null;
    return next();
  }

  pendingRandomisedHandle = null;
  const resolvedHandle = resolveRandomisedProductHandle(handle);
  if (resolvedHandle === handle) {
    return next();
  }

  pendingRandomisedHandle = resolvedHandle;
  return next({
    name: 'product',
    params: {
      handle: resolvedHandle,
    },
    query: to.query,
    hash: to.hash,
    state: {
      resolvedProductHandle: resolvedHandle,
    },
  });
};
